export const HomeIcon = () => (
  <svg
    width="25"
    height="28"
    viewBox="0 0 25 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.34375 25.6667H8.20312V15.9444H16.7969V25.6667H22.6562V10.5L12.5 2.91667L2.34375 10.5V25.6667ZM0 28V9.33333L12.5 0L25 9.33333V28H14.4531V18.2778H10.5469V28H0Z"
      fill="currentColor"
    />
  </svg>
);

export const SimulationIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 26C11.2017 26 9.51167 25.6589 7.93 24.9766C6.34833 24.2944 4.9725 23.3685 3.8025 22.1989C2.6325 21.0294 1.70625 19.6541 1.02375 18.0729C0.34125 16.4919 0 14.8025 0 13.0047C0 11.2071 0.34113 9.51696 1.02339 7.93433C1.70565 6.35194 2.63154 4.97539 3.80106 3.80467C4.97057 2.63394 6.34593 1.70721 7.92711 1.02447C9.50806 0.341491 11.1975 0 12.9953 0C14.7929 0 16.483 0.341249 18.0657 1.02375C19.6481 1.70625 21.0246 2.6325 22.1953 3.8025C23.3661 4.9725 24.2928 6.34833 24.9755 7.93C25.6585 9.51167 26 11.2017 26 13V23.6665C26 24.3083 25.7715 24.8577 25.3146 25.3146C24.8577 25.7715 24.3083 26 23.6665 26H13ZM13 24.5556C16.2259 24.5556 18.9583 23.4361 21.1972 21.1972C23.4361 18.9583 24.5556 16.2259 24.5556 13C24.5556 9.77407 23.4361 7.04167 21.1972 4.80278C18.9583 2.56389 16.2259 1.44444 13 1.44444C9.77407 1.44444 7.04167 2.56389 4.80278 4.80278C2.56389 7.04167 1.44444 9.77407 1.44444 13C1.44444 13.6832 1.49909 14.3545 1.60839 15.0139C1.71768 15.6731 1.89078 16.311 2.12767 16.9278L7.25003 11.8054L12.0445 15.8138L18.4694 9.38889H15.1667V7.94444H20.9444V13.7222H19.5V10.4473L12.1055 17.8057L7.37497 13.7612L2.78056 18.3556C3.73606 20.2019 5.12032 21.6968 6.93333 22.8403C8.74635 23.9838 10.7686 24.5556 13 24.5556ZM23.5 24.6112C23.7981 24.6112 24.0578 24.5005 24.2793 24.2793C24.5005 24.0578 24.6112 23.7981 24.6112 23.5C24.6112 23.2018 24.5005 22.942 24.2793 22.7208C24.0578 22.4995 23.7981 22.3889 23.5 22.3889C23.2018 22.3889 22.942 22.4995 22.7208 22.7208C22.4995 22.942 22.3889 23.2018 22.3889 23.5C22.3889 23.7981 22.4995 24.0578 22.7208 24.2793C22.942 24.5005 23.2018 24.6112 23.5 24.6112Z"
      fill="currentColor"
    />
  </svg>
);

export const AssetAllocationIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4375 11.5625H23.0938C22.8646 9.02083 21.8385 6.81771 20.0156 4.95312C18.1927 3.08854 16 2.07292 13.4375 1.90625V11.5625ZM11.5625 23.0938V1.90625C8.83333 2.13542 6.53646 3.27083 4.67188 5.3125C2.80729 7.35417 1.875 9.75 1.875 12.5C1.875 15.25 2.80729 17.6458 4.67188 19.6875C6.53646 21.7292 8.83333 22.8646 11.5625 23.0938ZM13.4375 23.0938C16 22.9271 18.1927 21.9115 20.0156 20.0469C21.8385 18.1823 22.8646 15.9792 23.0938 13.4375H13.4375V23.0938ZM12.5 25C10.7708 25 9.14583 24.6719 7.625 24.0156C6.10417 23.3594 4.78125 22.4688 3.65625 21.3438C2.53125 20.2188 1.64062 18.8958 0.984375 17.375C0.328125 15.8542 0 14.2292 0 12.5C0 10.7708 0.328125 9.14583 0.984375 7.625C1.64062 6.10417 2.53125 4.78125 3.65625 3.65625C4.78125 2.53125 6.10417 1.64062 7.625 0.984375C9.14583 0.328125 10.7708 0 12.5 0C14.2292 0 15.8542 0.328125 17.375 0.984375C18.8958 1.64062 20.2188 2.53125 21.3438 3.65625C22.4688 4.78125 23.3594 6.10417 24.0156 7.625C24.6719 9.14583 25 10.7708 25 12.5C25 14.2292 24.6719 15.8542 24.0156 17.375C23.3594 18.8958 22.4688 20.2188 21.3438 21.3438C20.2188 22.4688 18.8958 23.3594 17.375 24.0156C15.8542 24.6719 14.2292 25 12.5 25Z"
      fill="currentColor"
    />
  </svg>
);

export const AssetClassAnalysisIcon = () => (
  <svg
    width="41"
    height="22"
    viewBox="0 0 41 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.2422 11.0863L35.2939 5.70703"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1367 10.4141L23.8609 11.7589"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.70703 16.4652L12.4312 11.0859"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.68966 21.1723C5.17511 21.1723 6.37931 19.9681 6.37931 18.4826C6.37931 16.9972 5.17511 15.793 3.68966 15.793C2.2042 15.793 1 16.9972 1 18.4826C1 19.9681 2.2042 21.1723 3.68966 21.1723Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4475 11.7582C15.9329 11.7582 17.1371 10.554 17.1371 9.06856C17.1371 7.58311 15.9329 6.37891 14.4475 6.37891C12.962 6.37891 11.7578 7.58311 11.7578 9.06856C11.7578 10.554 12.962 11.7582 14.4475 11.7582Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5529 15.7934C28.0384 15.7934 29.2426 14.5892 29.2426 13.1037C29.2426 11.6183 28.0384 10.4141 26.5529 10.4141C25.0675 10.4141 23.8633 11.6183 23.8633 13.1037C23.8633 14.5892 25.0675 15.7934 26.5529 15.7934Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.3107 6.37931C38.7962 6.37931 40.0004 5.17511 40.0004 3.68966C40.0004 2.2042 38.7962 1 37.3107 1C35.8253 1 34.6211 2.2042 34.6211 3.68966C34.6211 5.17511 35.8253 6.37931 37.3107 6.37931Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FinancialPlanningIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5938 21.4688H13.3125V19.8438C14.5833 19.6979 15.5729 19.3073 16.2812 18.6719C16.9896 18.0365 17.3438 17.1875 17.3438 16.125C17.3438 15.0625 17.0417 14.1979 16.4375 13.5312C15.8333 12.8646 14.8125 12.2292 13.375 11.625C12.1667 11.125 11.2917 10.6771 10.75 10.2812C10.2083 9.88542 9.9375 9.35417 9.9375 8.6875C9.9375 8.04167 10.1719 7.53125 10.6406 7.15625C11.1094 6.78125 11.75 6.59375 12.5625 6.59375C13.1875 6.59375 13.7292 6.73958 14.1875 7.03125C14.6458 7.32292 15.0312 7.76042 15.3438 8.34375L16.8438 7.625C16.4896 6.89583 16.0208 6.32292 15.4375 5.90625C14.8542 5.48958 14.1667 5.23958 13.375 5.15625V3.5625H11.6562V5.15625C10.5938 5.30208 9.75521 5.69271 9.14062 6.32812C8.52604 6.96354 8.21875 7.75 8.21875 8.6875C8.21875 9.70833 8.53125 10.5208 9.15625 11.125C9.78125 11.7292 10.7188 12.2917 11.9688 12.8125C13.3646 13.3958 14.3229 13.9219 14.8438 14.3906C15.3646 14.8594 15.625 15.4375 15.625 16.125C15.625 16.7917 15.349 17.3281 14.7969 17.7344C14.2448 18.1406 13.5521 18.3438 12.7188 18.3438C11.9062 18.3438 11.1823 18.1146 10.5469 17.6562C9.91146 17.1979 9.46875 16.5729 9.21875 15.7812L7.625 16.3125C8.0625 17.2708 8.59896 18.026 9.23438 18.5781C9.86979 19.1302 10.6562 19.5312 11.5938 19.7812V21.4688ZM12.5 25C10.7917 25 9.17708 24.6719 7.65625 24.0156C6.13542 23.3594 4.80729 22.4635 3.67188 21.3281C2.53646 20.1927 1.64062 18.8646 0.984375 17.3438C0.328125 15.8229 0 14.2083 0 12.5C0 10.7708 0.328125 9.14583 0.984375 7.625C1.64062 6.10417 2.53646 4.78125 3.67188 3.65625C4.80729 2.53125 6.13542 1.64062 7.65625 0.984375C9.17708 0.328125 10.7917 0 12.5 0C14.2292 0 15.8542 0.328125 17.375 0.984375C18.8958 1.64062 20.2188 2.53125 21.3438 3.65625C22.4688 4.78125 23.3594 6.10417 24.0156 7.625C24.6719 9.14583 25 10.7708 25 12.5C25 14.2083 24.6719 15.8229 24.0156 17.3438C23.3594 18.8646 22.4688 20.1927 21.3438 21.3281C20.2188 22.4635 18.8958 23.3594 17.375 24.0156C15.8542 24.6719 14.2292 25 12.5 25ZM12.5 23.125C15.4583 23.125 17.9688 22.0885 20.0312 20.0156C22.0938 17.9427 23.125 15.4375 23.125 12.5C23.125 9.54167 22.0938 7.03125 20.0312 4.96875C17.9688 2.90625 15.4583 1.875 12.5 1.875C9.5625 1.875 7.05729 2.90625 4.98438 4.96875C2.91146 7.03125 1.875 9.54167 1.875 12.5C1.875 15.4375 2.91146 17.9427 4.98438 20.0156C7.05729 22.0885 9.5625 23.125 12.5 23.125Z"
      fill="currentColor"
    />
  </svg>
);

export const PortfoliosIcon = () => (
  <svg
    width="30"
    height="27"
    viewBox="0 0 30 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0022 24.6744V24.7744H24.1022H24.8313H24.9313V24.6744V24.0731C25.4428 24.0021 25.8544 23.8342 26.1576 23.5622C26.4818 23.2714 26.6415 22.8828 26.6415 22.4073C26.6415 21.9365 26.5071 21.5443 26.2312 21.2398C25.9603 20.9409 25.5114 20.6644 24.8966 20.406L24.8961 20.4058C24.3853 20.1944 24.0231 20.0081 23.8032 19.8474C23.599 19.6982 23.4995 19.5027 23.4995 19.252C23.4995 19.0058 23.5871 18.819 23.7603 18.6805C23.936 18.5399 24.1832 18.4638 24.5131 18.4638C24.7622 18.4638 24.9727 18.5217 25.1488 18.6337C25.326 18.7464 25.4787 18.9178 25.6049 19.1534L25.6501 19.2377L25.7363 19.1964L26.3726 18.8914L26.4633 18.848L26.4194 18.7576C26.2628 18.4352 26.0537 18.1784 25.791 17.9907C25.5505 17.819 25.2721 17.7111 24.9578 17.6656V17.0778V16.9778H24.8578H24.1287H24.0287V17.0778V17.6681C23.6003 17.7411 23.2516 17.9107 22.9896 18.1815C22.7096 18.471 22.5703 18.8301 22.5703 19.252C22.5703 19.7071 22.7105 20.0796 22.9986 20.358C23.2763 20.6264 23.6866 20.8709 24.2227 21.0943C24.8137 21.3413 25.2066 21.5591 25.414 21.7458C25.6144 21.9262 25.7124 22.1446 25.7124 22.4073C25.7124 22.6573 25.6112 22.8554 25.4018 23.0095C25.1882 23.1667 24.9163 23.2486 24.5794 23.2486C24.2549 23.2486 23.9684 23.1575 23.7165 22.9758C23.4655 22.7948 23.2899 22.548 23.1899 22.2314L23.1593 22.1345L23.063 22.1666L22.3868 22.392L22.2813 22.4272L22.3275 22.5284C22.5176 22.9448 22.7529 23.2779 23.0356 23.5235C23.3011 23.7542 23.6241 23.9239 24.0022 24.0343V24.6744ZM22.3921 25.8467C23.0502 26.1306 23.7487 26.2725 24.4866 26.2725C25.2332 26.2725 25.9362 26.1307 26.5944 25.8467C27.2509 25.5634 27.8229 25.1762 28.3096 24.6851C28.7959 24.1942 29.1807 23.6202 29.4639 22.964C29.7478 22.3059 29.8897 21.6074 29.8897 20.8694C29.8897 20.1228 29.7479 19.4199 29.4639 18.7616C29.1807 18.1053 28.7958 17.5334 28.3092 17.0468C27.8227 16.5603 27.2507 16.1754 26.5944 15.8922C25.9362 15.6082 25.2332 15.4664 24.4866 15.4664C23.7487 15.4664 23.0502 15.6082 22.3921 15.8922C21.7358 16.1754 21.1619 16.5601 20.671 17.0465C20.1799 17.5331 19.7927 18.1051 19.5094 18.7616C19.2253 19.4199 19.0836 20.1228 19.0836 20.8694C19.0836 21.6074 19.2254 22.3059 19.5094 22.964C19.7926 23.6204 20.1797 24.1945 20.6706 24.6854C21.1616 25.1763 21.7356 25.5634 22.3921 25.8467ZM27.6108 23.9874C26.7548 24.8477 25.7154 25.277 24.4866 25.277C23.2669 25.277 22.2295 24.8478 21.3689 23.9872C20.5083 23.1266 20.079 22.0892 20.079 20.8694C20.079 19.6406 20.5084 18.6012 21.3687 17.7452C22.2293 16.889 23.2667 16.4619 24.4866 16.4619C25.7156 16.4619 26.755 16.8891 27.611 17.7451C28.4669 18.601 28.8942 19.6405 28.8942 20.8694C28.8942 22.0893 28.4671 23.1268 27.6108 23.9874Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
    <path
      d="M9.33203 5.71733V2.87642C9.33203 1.93324 10.0652 1.17188 10.9734 1.17188H17.5391C18.4474 1.17188 19.1805 1.93324 19.1805 2.87642V5.71733"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M18.4245 25.4147H3.87902C2.70705 25.4147 1.75781 24.4431 1.75781 23.2435V14.8086"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M27.5152 14.0521V6.7036C27.5152 6.16193 27.0379 5.71875 26.4545 5.71875H2.06061C1.47727 5.71875 1 6.16193 1 6.7036V12.6127C1 14.2426 2.42652 15.5672 4.18182 15.5672H11.6061"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M14.257 19.3538C12.7933 19.3538 11.6055 18.1659 11.6055 16.7023V15.1114C11.6055 14.5281 12.0827 14.0508 12.6661 14.0508H15.8479C16.4312 14.0508 16.9085 14.5281 16.9085 15.1114V16.7023C16.9085 18.1659 15.7206 19.3538 14.257 19.3538Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="14.0683"
      y="15.7558"
      width="0.378788"
      height="1.89394"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.378788"
    />
  </svg>
);

export const HelpIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4844 21.4797C13.8901 21.4797 14.2328 21.3396 14.5125 21.0595C14.7921 20.7793 14.932 20.4364 14.932 20.0306C14.932 19.6248 14.7919 19.2821 14.5117 19.0025C14.2316 18.7228 13.8886 18.583 13.4828 18.583C13.0771 18.583 12.7344 18.7231 12.4547 19.0033C12.1751 19.2834 12.0352 19.6264 12.0352 20.0321C12.0352 20.4379 12.1753 20.7806 12.4555 21.0603C12.7356 21.3399 13.0786 21.4797 13.4844 21.4797ZM12.4779 16.3913H14.4783C14.4965 15.6917 14.599 15.1328 14.7858 14.7147C14.9725 14.2966 15.4257 13.7423 16.1453 13.0518C16.7702 12.4269 17.2489 11.8498 17.5814 11.3206C17.9139 10.7913 18.0801 10.1663 18.0801 9.44555C18.0801 8.22242 17.6406 7.26697 16.7616 6.57921C15.8826 5.89146 14.8427 5.54759 13.6421 5.54759C12.4561 5.54759 11.4746 5.86414 10.6975 6.49725C9.92052 7.13033 9.36623 7.87591 9.03465 8.73399L10.8601 9.46637C11.0332 8.9945 11.3292 8.53495 11.7483 8.08769C12.1673 7.64042 12.7895 7.41678 13.6148 7.41678C14.4547 7.41678 15.0755 7.6468 15.4772 8.10684C15.8789 8.56686 16.0798 9.07289 16.0798 9.62492C16.0798 10.1077 15.9422 10.5495 15.6671 10.9503C15.392 11.3511 15.0413 11.7383 14.615 12.1118C13.6822 12.9535 13.0928 13.6248 12.8469 14.1258C12.6009 14.6269 12.4779 15.382 12.4779 16.3913ZM13.5024 27C11.6352 27 9.88015 26.6457 8.23722 25.937C6.59427 25.2284 5.16514 24.2667 3.94983 23.052C2.73449 21.8372 1.77235 20.4087 1.06341 18.7664C0.354471 17.1242 0 15.3696 0 13.5024C0 11.6352 0.354317 9.88015 1.06295 8.23722C1.77158 6.59427 2.73328 5.16514 3.94805 3.94983C5.16284 2.73449 6.59134 1.77235 8.23356 1.06341C9.87576 0.354472 11.6304 0 13.4976 0C15.3648 0 17.1198 0.354318 18.7628 1.06295C20.4057 1.77158 21.8349 2.73328 23.0502 3.94805C24.2655 5.16284 25.2276 6.59135 25.9366 8.23357C26.6455 9.87576 27 11.6304 27 13.4976C27 15.3648 26.6457 17.1198 25.937 18.7628C25.2284 20.4057 24.2667 21.8349 23.052 23.0502C21.8372 24.2655 20.4087 25.2276 18.7664 25.9366C17.1242 26.6455 15.3696 27 13.5024 27ZM13.5 24.8685C16.6737 24.8685 19.3619 23.7671 21.5645 21.5645C23.7671 19.3619 24.8685 16.6737 24.8685 13.5C24.8685 10.3263 23.7671 7.63814 21.5645 5.43551C19.3619 3.23287 16.6737 2.13155 13.5 2.13155C10.3263 2.13155 7.63814 3.23287 5.4355 5.43551C3.23287 7.63814 2.13155 10.3263 2.13155 13.5C2.13155 16.6737 3.23287 19.3619 5.4355 21.5645C7.63814 23.7671 10.3263 24.8685 13.5 24.8685Z"
      fill="currentColor"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08333 25C1.52778 25 1.04167 24.7917 0.625 24.375C0.208333 23.9583 0 23.4722 0 22.9167V2.08333C0 1.52778 0.208333 1.04167 0.625 0.625C1.04167 0.208333 1.52778 0 2.08333 0H12.1875V2.08333H2.08333V22.9167H12.1875V25H2.08333ZM18.9583 18.5764L17.4653 17.0833L21.0069 13.5417H8.85417V11.4583H20.9375L17.3958 7.91667L18.8889 6.42361L25 12.5347L18.9583 18.5764Z"
      fill="currentColor"
    />
  </svg>
);
